import { render, staticRenderFns } from "./LvSnackBar.vue?vue&type=template&id=6633d612"
import script from "./LvSnackBar.vue?vue&type=script&lang=js"
export * from "./LvSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports